import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
const defaultOptions = {} as const;

export type AuthorizationQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
}>;

export type AuthorizationQueryResult = { __typename?: 'Query' } & {
  account?: GraphQLTypes.Maybe<
    { __typename?: 'Account' } & {
      permissions?: GraphQLTypes.Maybe<
        { __typename?: 'AccountPermissions' } & {
          bookings?: GraphQLTypes.Maybe<
            { __typename?: 'BookingAccountPermissions' } & {
              canAccessRoute?: GraphQLTypes.Maybe<
                { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
              >;
              canCreate?: GraphQLTypes.Maybe<
                { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
              >;
            }
          >;
          insights?: GraphQLTypes.Maybe<
            { __typename?: 'InsightsAccountPermissions' } & {
              analytics?: GraphQLTypes.Maybe<
                { __typename?: 'AnalyticsAccountPermissions' } & {
                  canAccessRoute?: GraphQLTypes.Maybe<
                    { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
                  >;
                }
              >;
              freightSpend?: GraphQLTypes.Maybe<
                { __typename?: 'FreightSpendAccountPermissions' } & {
                  canAccessRoute?: GraphQLTypes.Maybe<
                    { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
                  >;
                }
              >;
              intakePlanning?: GraphQLTypes.Maybe<
                { __typename?: 'IntakePlanningAccountPermissions' } & {
                  canAccessRoute?: GraphQLTypes.Maybe<
                    { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
                  >;
                }
              >;
              warehousing?: GraphQLTypes.Maybe<
                { __typename?: 'WarehousingAccountPermissions' } & {
                  canAccessRoute?: GraphQLTypes.Maybe<
                    { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
                  >;
                }
              >;
            }
          >;
          products?: GraphQLTypes.Maybe<
            { __typename?: 'ProductAccountPermissions' } & {
              canAccessRoute?: GraphQLTypes.Maybe<
                { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
              >;
              canCreate?: GraphQLTypes.Maybe<
                { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
              >;
            }
          >;
          purchaseOrders?: GraphQLTypes.Maybe<
            { __typename?: 'PurchaseOrderAccountPermissions' } & {
              canAccessRoute?: GraphQLTypes.Maybe<
                { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
              >;
              canCreate?: GraphQLTypes.Maybe<
                { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
              >;
            }
          >;
        }
      >;
    }
  >;
  authorizationRole: { __typename?: 'AuthorizationRole' } & Pick<
    GraphQLTypes.AuthorizationRole,
    'isAdmin' | 'isAgent' | 'isConsignmentParty'
  >;
  globalPermissions: { __typename?: 'GlobalPermissions' } & {
    accounts?: GraphQLTypes.Maybe<
      { __typename?: 'AccountGlobalPermissions' } & {
        canAccessRoute?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canActivate?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canCreateActivityFeed?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canCreateBusinessUnits?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canCreateLocations?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canCreateManagedAccounts?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canCreateRateCards?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canDeactivate?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canDeleteRateCards?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canEditBusinessUnits?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canInviteConnections?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canLinkConnections?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canManageAccountGeneral?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canManageConnections?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canManageMembers?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canManageWebhooks?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canSwitch?: GraphQLTypes.Maybe<{ __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>>;
        canUpdateDemoMode?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canViewAccountGeneral?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canViewAccountSettings?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canViewAuthentication?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canViewBusinessUnits?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canViewConnections?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canViewLocations?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canViewMembers?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canViewRateCards?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
        canViewWebhooks?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
      }
    >;
    apiConsole?: GraphQLTypes.Maybe<
      { __typename?: 'APIConsoleGlobalPermissions' } & {
        canAccessRoute?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
      }
    >;
    bookings?: GraphQLTypes.Maybe<
      { __typename?: 'BookingGlobalPermissions' } & {
        canRequest?: GraphQLTypes.Maybe<{ __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>>;
      }
    >;
    insights?: GraphQLTypes.Maybe<
      { __typename?: 'InsightsGlobalPermissions' } & {
        freightSpendCanAccessRoute?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
      }
    >;
    platform?: GraphQLTypes.Maybe<
      { __typename?: 'PlatformGlobalPermissions' } & {
        canCreateAccounts?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
      }
    >;
    rateCards?: GraphQLTypes.Maybe<
      { __typename?: 'RateCardGlobalPermissions' } & {
        canAccessRoute?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
      }
    >;
    settings?: GraphQLTypes.Maybe<
      { __typename?: 'SettingsGlobalPermissions' } & {
        notificationSettings?: GraphQLTypes.Maybe<
          { __typename?: 'NotificationSettingsGlobalPermissions' } & {
            booking?: GraphQLTypes.Maybe<
              { __typename?: 'BookingNotificationSettingsGlobalPermissions' } & {
                canToggleAutoSubscribe?: GraphQLTypes.Maybe<
                  { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
                >;
              }
            >;
          }
        >;
      }
    >;
    user?: GraphQLTypes.Maybe<
      { __typename?: 'UserGlobalPermissions' } & {
        canCreateApiKeys?: GraphQLTypes.Maybe<
          { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
        >;
      }
    >;
  };
  legacyGlobalPermissions: { __typename?: 'LegacyGlobalPermissions' } & {
    accounts?: GraphQLTypes.Maybe<
      { __typename?: 'Accounts' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canSwitch: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    accruals?: GraphQLTypes.Maybe<
      { __typename?: 'Accruals' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canCreate: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    adminPanel?: GraphQLTypes.Maybe<
      { __typename?: 'AdminPanel' } & {
        canView: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    backoffice?: GraphQLTypes.Maybe<
      { __typename?: 'Backoffice' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    bookingRequests?: GraphQLTypes.Maybe<
      { __typename?: 'BookingRequests' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canViewApprovalRequired: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canViewManufacturerRequested: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canViewRejected: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    bookings?: GraphQLTypes.Maybe<
      { __typename?: 'Bookings' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canChangeCustomsOnly: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canChangeMultiStop: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canChangeShipmentType: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canChangeTradeRole: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canChangeTruckSwap: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canCreate: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canExport: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canPin: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canQuote: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canRequest: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canViewCustomers: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canViewDocumentPermissions: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    consolidation?: GraphQLTypes.Maybe<
      { __typename?: 'Consolidation' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canAddConsolidatedShipment: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canManageConsolidatedShipment: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    dashboard?: GraphQLTypes.Maybe<
      { __typename?: 'Dashboard' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canViewActionItems: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    documentCreation?: GraphQLTypes.Maybe<
      { __typename?: 'DocumentCreation' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    freightSpend?: GraphQLTypes.Maybe<
      { __typename?: 'FreightSpend' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    intakePlanning?: GraphQLTypes.Maybe<
      { __typename?: 'IntakePlanning' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    networks?: GraphQLTypes.Maybe<
      { __typename?: 'Networks' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canManage: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    operationsDashboard?: GraphQLTypes.Maybe<
      { __typename?: 'OperationsDashboard' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    operationsSettings?: GraphQLTypes.Maybe<
      { __typename?: 'OperationsSettings' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    packingLists?: GraphQLTypes.Maybe<
      { __typename?: 'PackingLists' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    products?: GraphQLTypes.Maybe<
      { __typename?: 'Products' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    productsCsvImport?: GraphQLTypes.Maybe<
      { __typename?: 'ProductsCsvImport' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canImport: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    productSettings?: GraphQLTypes.Maybe<
      { __typename?: 'ProductSettings' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    purchaseOrders?: GraphQLTypes.Maybe<
      { __typename?: 'PurchaseOrders' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canAssignAgent: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canCreate: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canExport: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canViewCustomers: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    quotes?: GraphQLTypes.Maybe<
      { __typename?: 'Quotes' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    rulesEngine?: GraphQLTypes.Maybe<
      { __typename?: 'RulesEngine' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    settings?: GraphQLTypes.Maybe<
      { __typename?: 'Settings' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        canSetPreferences: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
        notificationSettings?: GraphQLTypes.Maybe<
          { __typename?: 'NotificationSettings' } & {
            booking?: GraphQLTypes.Maybe<
              { __typename?: 'NotificationSettingsBookingType' } & {
                canSetActionItemSettings: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetApprovedBookingSetting: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetBookingRequestSettings: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetCargoSettings: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
                canSetCollectionSettings: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetDeliverySettings: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
                canSetEtaSettings: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
                canSetIssuesSettings: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
                canSetManufacturerRequestedBookingSetting: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetQuoteOptionSettings: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetRequiredCustomerApprovalForBookingSetting: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetSlackSettings: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
                canSetTextMessageFromAgentForwarderSetting: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetTextMessageFromCustomerUserSetting: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetTextMessageFromForwarderSetting: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetTextMessageFromManufacturerSetting: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetTextMessageSettings: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
              }
            >;
            purchaseOrder?: GraphQLTypes.Maybe<
              { __typename?: 'NotificationSettingsPurchaseOrderType' } & {
                canSetIssuesSettings: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
                canSetLotsCargoReadyDateSettings: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetLotsDeliveryEstimateSettings: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetPurchaseOrderClosedSetting: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetPurchaseOrderCreatedSetting: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetTextMessageFromAgentForwarderSetting: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetTextMessageFromCustomerUserSetting: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetTextMessageFromForwarderSetting: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetTextMessageFromManufacturerSetting: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
                canSetTextMessageSettings: { __typename?: 'AuthorizationResult' } & Pick<
                  GraphQLTypes.AuthorizationResult,
                  'value'
                >;
              }
            >;
          }
        >;
      }
    >;
    taskList?: GraphQLTypes.Maybe<
      { __typename?: 'TaskList' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    workflows?: GraphQLTypes.Maybe<
      { __typename?: 'Workflows' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
    zencargoNetwork?: GraphQLTypes.Maybe<
      { __typename?: 'ZencargoNetwork' } & {
        canAccessRoute: { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>;
      }
    >;
  };
};

export const AuthorizationQueryDocument = /*#__PURE__*/ gql`
  query authorizationQuery($accountId: String!) {
    account(accountId: $accountId) {
      permissions {
        bookings {
          canAccessRoute {
            value
          }
          canCreate {
            value
          }
        }
        insights {
          analytics {
            canAccessRoute {
              value
            }
          }
          freightSpend {
            canAccessRoute {
              value
            }
          }
          intakePlanning {
            canAccessRoute {
              value
            }
          }
          warehousing {
            canAccessRoute {
              value
            }
          }
        }
        products {
          canAccessRoute {
            value
          }
          canCreate {
            value
          }
        }
        purchaseOrders {
          canAccessRoute {
            value
          }
          canCreate {
            value
          }
        }
      }
    }
    authorizationRole {
      isAdmin
      isAgent
      isConsignmentParty
    }
    globalPermissions {
      accounts {
        canAccessRoute {
          value
        }
        canActivate {
          value
        }
        canCreateActivityFeed {
          value
        }
        canCreateBusinessUnits {
          value
        }
        canCreateLocations {
          value
        }
        canCreateManagedAccounts {
          value
        }
        canCreateRateCards {
          value
        }
        canDeactivate {
          value
        }
        canDeleteRateCards {
          value
        }
        canEditBusinessUnits {
          value
        }
        canInviteConnections {
          value
        }
        canLinkConnections {
          value
        }
        canManageAccountGeneral {
          value
        }
        canManageConnections {
          value
        }
        canManageMembers {
          value
        }
        canManageWebhooks {
          value
        }
        canSwitch {
          value
        }
        canUpdateDemoMode {
          value
        }
        canViewAccountGeneral {
          value
        }
        canViewAccountSettings {
          value
        }
        canViewAuthentication {
          value
        }
        canViewBusinessUnits {
          value
        }
        canViewConnections {
          value
        }
        canViewLocations {
          value
        }
        canViewMembers {
          value
        }
        canViewRateCards {
          value
        }
        canViewWebhooks {
          value
        }
      }
      apiConsole {
        canAccessRoute {
          value
        }
      }
      bookings {
        canRequest {
          value
        }
      }
      insights {
        freightSpendCanAccessRoute {
          value
        }
      }
      platform {
        canCreateAccounts {
          value
        }
      }
      rateCards {
        canAccessRoute {
          value
        }
      }
      settings {
        notificationSettings {
          booking {
            canToggleAutoSubscribe {
              value
            }
          }
        }
      }
      user {
        canCreateApiKeys {
          value
        }
      }
    }
    legacyGlobalPermissions {
      accounts {
        canAccessRoute {
          value
        }
        canSwitch {
          value
        }
      }
      accruals {
        canAccessRoute {
          value
        }
        canCreate {
          value
        }
      }
      adminPanel {
        canView {
          value
        }
      }
      backoffice {
        canAccessRoute {
          value
        }
      }
      bookingRequests {
        canAccessRoute {
          value
        }
        canViewApprovalRequired {
          value
        }
        canViewManufacturerRequested {
          value
        }
        canViewRejected {
          value
        }
      }
      bookings {
        canAccessRoute {
          value
        }
        canChangeCustomsOnly {
          value
        }
        canChangeMultiStop {
          value
        }
        canChangeShipmentType {
          value
        }
        canChangeTradeRole {
          value
        }
        canChangeTruckSwap {
          value
        }
        canCreate {
          value
        }
        canExport {
          value
        }
        canPin {
          value
        }
        canQuote {
          value
        }
        canRequest {
          value
        }
        canViewCustomers {
          value
        }
        canViewDocumentPermissions {
          value
        }
      }
      consolidation {
        canAccessRoute {
          value
        }
        canAddConsolidatedShipment {
          value
        }
        canManageConsolidatedShipment {
          value
        }
      }
      dashboard {
        canAccessRoute {
          value
        }
        canViewActionItems {
          value
        }
      }
      documentCreation {
        canAccessRoute {
          value
        }
      }
      freightSpend {
        canAccessRoute {
          value
        }
      }
      intakePlanning {
        canAccessRoute {
          value
        }
      }
      networks {
        canAccessRoute {
          value
        }
        canManage {
          value
        }
      }
      operationsDashboard {
        canAccessRoute {
          value
        }
      }
      operationsSettings {
        canAccessRoute {
          value
        }
      }
      packingLists {
        canAccessRoute {
          value
        }
      }
      products {
        canAccessRoute {
          value
        }
      }
      productsCsvImport {
        canAccessRoute {
          value
        }
        canImport {
          value
        }
      }
      productSettings {
        canAccessRoute {
          value
        }
      }
      purchaseOrders {
        canAccessRoute {
          value
        }
        canAssignAgent {
          value
        }
        canCreate {
          value
        }
        canExport {
          value
        }
        canViewCustomers {
          value
        }
      }
      quotes {
        canAccessRoute {
          value
        }
      }
      rulesEngine {
        canAccessRoute {
          value
        }
      }
      settings {
        canAccessRoute {
          value
        }
        canSetPreferences {
          value
        }
        notificationSettings {
          booking {
            canSetActionItemSettings {
              value
            }
            canSetApprovedBookingSetting {
              value
            }
            canSetBookingRequestSettings {
              value
            }
            canSetCargoSettings {
              value
            }
            canSetCollectionSettings {
              value
            }
            canSetDeliverySettings {
              value
            }
            canSetEtaSettings {
              value
            }
            canSetIssuesSettings {
              value
            }
            canSetManufacturerRequestedBookingSetting {
              value
            }
            canSetQuoteOptionSettings {
              value
            }
            canSetRequiredCustomerApprovalForBookingSetting {
              value
            }
            canSetSlackSettings {
              value
            }
            canSetTextMessageFromAgentForwarderSetting {
              value
            }
            canSetTextMessageFromCustomerUserSetting {
              value
            }
            canSetTextMessageFromForwarderSetting {
              value
            }
            canSetTextMessageFromManufacturerSetting {
              value
            }
            canSetTextMessageSettings {
              value
            }
          }
          purchaseOrder {
            canSetIssuesSettings {
              value
            }
            canSetLotsCargoReadyDateSettings {
              value
            }
            canSetLotsDeliveryEstimateSettings {
              value
            }
            canSetPurchaseOrderClosedSetting {
              value
            }
            canSetPurchaseOrderCreatedSetting {
              value
            }
            canSetTextMessageFromAgentForwarderSetting {
              value
            }
            canSetTextMessageFromCustomerUserSetting {
              value
            }
            canSetTextMessageFromForwarderSetting {
              value
            }
            canSetTextMessageFromManufacturerSetting {
              value
            }
            canSetTextMessageSettings {
              value
            }
          }
        }
      }
      taskList {
        canAccessRoute {
          value
        }
      }
      workflows {
        canAccessRoute {
          value
        }
      }
      zencargoNetwork {
        canAccessRoute {
          value
        }
      }
    }
  }
`;

/**
 * __useAuthorizationQuery__
 *
 * To run a query within a React component, call `useAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizationQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAuthorizationQuery(
  baseOptions: Apollo.QueryHookOptions<AuthorizationQueryResult, AuthorizationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<AuthorizationQueryResult, AuthorizationQueryVariables>(AuthorizationQueryDocument, options);
}
export function useAuthorizationQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AuthorizationQueryResult, AuthorizationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<AuthorizationQueryResult, AuthorizationQueryVariables>(AuthorizationQueryDocument, options);
}
export type AuthorizationQueryHookResult = ReturnType<typeof useAuthorizationQuery>;
export type AuthorizationQueryLazyQueryHookResult = ReturnType<typeof useAuthorizationQueryLazyQuery>;
